/** Last N digits from a reference string (non-digits stripped first). */
export const getReferenceLastDigits = (value, digitCount = 4) => {
    const digitsOnly = (value ?? '').toString().replace(/\D/g, '');
    return digitsOnly.slice(-digitCount);
};

export const DEFAULT_REFERENCE_LAST_DIGITS = 4;

export const PARTIAL_REFERENCE_FIELDS = new Set(['reference_last', 'reference2_last']);

export const isPartialReferenceField = (field) => PARTIAL_REFERENCE_FIELDS.has(field);

export const hasPartialReferenceSelection = (columns) =>
    columns?.some(isPartialReferenceField);

export const BANK_AUTO_MATCH_REFERENCE_OPTIONS = [
    { field: 'reference_last', headerName: 'reference_last' },
    { field: 'reference2_last', headerName: 'reference2_last' },
];

export const CARD_AUTO_MATCH_REFERENCE_OPTIONS = [
    { field: 'reference_last', headerName: 'reference_last' },
];
